export default {
  methods: {
    commentService() {
      return this.$services.resource('plot_stage_comments').setCommentable(this.commentable.id);
    },
    editComment(comment) {
      this.$refs.ObservationForm.edit(comment);
    },
    saveComment(comment) {
      const payload = {
        ...comment,
        ...{
          commentableType: this.commentableType,
          commentableId: this.commentable.id,
        },
      };

      if (comment.id) {
        this.commentService()
          .update(payload.id, payload)
          .then((res) => {
            comment = res.data.data;
            const index = this.commentable.comments.findIndex((c) => c.id === comment.id);
            this.commentable.comments.splice(index, 1, comment);
            this.$refs.ObservationForm.reset();
            this.$success('Comentario actualizado con exito', 'Listo!');
          });
      } else {
        this.commentService()
          .create(payload)
          .then((res) => {
            comment = res.data.data;
            this.commentable.comments.unshift(comment);
            this.$refs.ObservationForm.reset();
            this.$success('Comentario guardado con exito', 'Listo!');
          });
      }
    },
    deleteComment(id) {
      this.commentService()
        .delete(id, { commentable_type: this.commentableType })
        .then(() => {
          this.$success('El comentario fue eliminado con éxito', 'Eliminado!');
          const index = this.commentable.comments.findIndex((c) => c.id === id);
          this.commentable.comments.splice(index, 1);
        });
    },
  },
};
